import { useLocation } from "react-router-dom";
import {
  ExcessPaymentReportContent,
  FullPaymentReportContent,
  UnpaidReportContent,
} from "../../components/report/payment";

export default function PaymentReport() {
    const location = useLocation();
  return (
    <>
      {location.state.page === "full" ? (
        <FullPaymentReportContent />
      ) : location.state.page === "excess" ? (
        <ExcessPaymentReportContent />
      ) : location.state.page === "unpaid" ? (
        <UnpaidReportContent />
      ) : (
        <FullPaymentReportContent />
      )}
    </>
  );
}
